import ComplexProvider from '../providers/ComplexProvider'

var ComplexService = function () {
  var complexes = []
  var complexesByComplexId = {}
  var complexesByDepartmentId = {}

  return {
    getComplexes: function () {
      return complexes
    },
    getComplexByComplexId: function (complexId) {
      return complexesByComplexId[complexId]
    },
    // Not the right place for cloning and sorting. This needs to be done in the controller
    /* getComplexesByName: function () {
        return complexes.slice().sort(function (a, b) {
            return (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0);
        });
    }, */
    getComplexesByDepartmentId: function (departmentId) {
      return complexesByDepartmentId[departmentId] || []
    },
    setComplexes: function (_complexes) {
      complexesByComplexId = {}
      complexesByDepartmentId = {}

      complexes = _complexes
      complexes.forEach(function (complex) {
        // Hash by ComplexId
        complexesByComplexId[complex.ComplexId] = complex

        // Hash by DepartmentId
        if (!complexesByDepartmentId[complex.DepartmentId]) {
          complexesByDepartmentId[complex.DepartmentId] = []
        }
        complexesByDepartmentId[complex.DepartmentId].push(complex)
      })

      // $rootScope.$broadcast('setComplexes', complexes)
    },
    updateComplex: function (_complex) {
      var complex = complexesByComplexId[_complex.ComplexId]
      // TO DO !update children maybe?
      complex.Name = _complex.Name
      complex.ParentComplexId = _complex.ParentComplexId

      // $rootScope.$broadcast('updateComplex', complex)
    },
    GetStatusUpdatesAsync: function (uniqueId, componentId, range) {
      return ComplexProvider.GetStatusUpdatesAsync(uniqueId, componentId, range)
    }
  }
}

export default new ComplexService()



// WEBPACK FOOTER //
// ./src/services/ComplexService.js